module.exports = __webpack_public_path__ + "static/img/wallet.11bea6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/wallet.png
// module id = Ea9Z
// module chunks = 1